<div class="dropdown" [ngClass]="{ 'dropdown-disabled': disabled }">
    <div class="title" (click)="toggleItems()" [attr.data-e2e-hook]="e2eHook">
        <span class="title-text">{{ title }}</span>
        <div class="caret-container">
            <div class="caret-down" [hidden]="displayItems"></div>
            <div class="caret-up" [hidden]="!displayItems"></div>
        </div>
    </div>
    <div class="items" [hidden]="!displayItems">
        <ul class="items-list">
            <li
                *ngFor="let item of items; let i = index"
                class="item"
                [ngClass]="{ 'item-selected': isSelected(item) }"
                (click)="selectItem(item)"
                [attr.data-e2e-hook]="e2eHook + 'item' + i"
            >
                <div class="item-title">
                    <strong>{{ item.textRows[0] }}</strong>
                </div>
                <div class="item-description">{{ item.textRows[1] }}</div>
            </li>
        </ul>
    </div>
</div>
